import { Grid } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  fromISO8601,
  fromISO8601_DATE,
  toISO8601_DATE,
  type ISO8601,
  type ISO8601_DATE,
} from "../../../utils/iso8601";
import { TimeZoneSelector } from "./time-zone-selector";

interface SpecificDateTimeSelectProps {
  date: {
    value: ISO8601_DATE | null;
    onChange: (val: string | null) => void;
  };
  time: {
    value: string | null;
    onChange: (val: string | null) => void;
  };
  timezone: {
    value: string | null;
    onChange: (val: string | null) => void;
  };
}

export const SpecificDateTimeSelect: FC<SpecificDateTimeSelectProps> = ({
  date,
  time,
  timezone,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container direction="row" spacing={2} alignItems="flex-start">
      <Grid size={{ md: 12, lg: 2 }}>
        <DatePicker
          label={t("Date")}
          minDate={new Date()}
          value={date.value ? fromISO8601_DATE(date.value) : null}
          onChange={(newValue) => date.onChange(toISO8601_DATE(newValue))}
          sx={{ width: "100%" }}
          slotProps={{ textField: { size: "small" } }}
        />
      </Grid>
      <Grid size={{ md: 12, lg: 2 }}>
        <TimePicker
          label={t("At")}
          value={time.value ? fromISO8601(`1970-01-01T${time.value}` as ISO8601) : null}
          onChange={(newTime) => {
            time.onChange(
              newTime
                ? `${newTime.getHours().toString().padStart(2, "0")}:${newTime.getMinutes().toString().padStart(2, "0")}`
                : null,
            );
          }}
          sx={{ width: "100%" }}
          slotProps={{
            textField: { size: "small" },
          }}
        />
      </Grid>
      <Grid size={{ md: 12, lg: 8 }}>
        <TimeZoneSelector
          value={timezone.value}
          onChangeTimeZone={(tz) => timezone.onChange(tz)}
          targetChannel={false}
          disabled={false}
          sx={{ width: "100%" }}
          size="small"
        />
      </Grid>
    </Grid>
  );
};
